// @flow
import { Record } from 'immutable';
import type { RecordOf, RecordFactory } from 'immutable';
import { isAcme } from 'isAcme';

export const MAX_TAG_LENGTH = isAcme ? 32 : 41;

type TagProps = {
  id: ?string,
  name: ?string,
  isDeleted: ?boolean,
  description: ?string,
  type: ?string,
  clientId: ?string,
  createdAt: ?string,
};
export type Tag = RecordOf<TagProps>;

export const mkTag: RecordFactory<TagProps> =
  Record({
    id: undefined,
    name: undefined,
    isDeleted: undefined,
    description: undefined,
    type: undefined,
    clientId: undefined,
    createdAt: undefined,
  });

